import { GetObjectCommand, PutObjectCommand } from '@aws-sdk/client-s3'
import {
  isNotFoundError,
  UPLOAD_BUCKET,
  withS3Client,
  type S3Io,
} from './s3'
import { getCurrentIdentityId } from '../auth/currentIdentity'

export const PROFILE_FILENAME = 'profile.json'

export type Profile = {
  creatorName?: string
  [key: string]: unknown
}

export function profileKey(identityId: string): string {
  return `${identityId}/${PROFILE_FILENAME}`
}

export async function loadProfile(io: S3Io, identityId?: string): Promise<Profile | null> {
  const id = identityId ?? getCurrentIdentityId()
  return withS3Client(io, async (client) => {
    try {
      const res = await client.send(
        new GetObjectCommand({ Bucket: UPLOAD_BUCKET, Key: profileKey(id) }),
      )
      if (!res.Body) return null
      const text = await res.Body.transformToString()
      if (!text) return null
      return JSON.parse(text) as Profile
    } catch (err) {
      if (isNotFoundError(err)) return null
      throw err
    }
  })
}

export async function saveProfile(
  io: S3Io,
  profile: Profile,
  identityId?: string,
): Promise<void> {
  const id = identityId ?? getCurrentIdentityId()
  await withS3Client(io, async (client) => {
    const body = new TextEncoder().encode(JSON.stringify(profile, null, 2))
    await client.send(
      new PutObjectCommand({
        Bucket: UPLOAD_BUCKET,
        Key: profileKey(id),
        Body: body,
        ContentType: 'application/json',
      }),
    )
  })
}
